// src/features/users/components/UserTable.tsx
import { Link } from 'react-router-dom';
import { Eye } from 'lucide-react';

import { formatPersianNumber, formatSolarDate } from '../../../app/components/foundation';
import type { User } from '../types/user.types';
import { UserStatusBadge } from './UserStatusBadge';

export interface UserTableProps {
  users: User[];
  scrollRef?: { current: HTMLDivElement | null };
}

/**
 * User list table. Presentation only — takes its rows as a prop and
 * stays decoupled from the API hook. Wrapped in
 * the shared glass-card `Card` primitive (noPadding, since the table
 * owns its own cell padding) with a horizontal-scroll rail for narrow
 * viewports — no table-specific JS, just CSS. Same structure as
 * customers/components/CustomerTable.tsx and
 * tenants/components/TenantTable.tsx.
 *
 * Rows navigate to the user workspace (/users/:id) on click.
 */
export function UserTable({ users, scrollRef }: UserTableProps) {
  return (
      <div
        ref={(node) => {
          if (scrollRef) scrollRef.current = node;
        }}
        className="vania-users-table-scroll"
      >
        <table className="vania-users-table">
          <thead>
            <tr>
              <th>کاربر</th>
              <th>Telegram</th>
              <th>تننت</th>
              <th>سرویس</th>
              <th>سفارش</th>
              <th>موجودی</th>
              <th>وضعیت</th>
              <th>تاریخ ایجاد</th>
              <th>عملیات</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr
                key={user.id}
                className="vania-users-table-row"
              >
                <td className="vania-users-table-name">{user.name}</td>
                <td className="vania-users-table-email" dir="ltr">{formatPersianNumber(user.telegramId)}</td>
                <td>{user.tenantName}</td>
                <td>{user.services ? formatPersianNumber(user.services.length) : 'در دسترس نیست'}</td>
                <td>{user.orders ? formatPersianNumber(user.orders.totalCount) : 'در دسترس نیست'}</td>
                <td dir="ltr">{user.wallet ? `${formatPersianNumber(user.wallet.balance)} تومان` : 'در دسترس نیست'}</td>
                <td>
                  <UserStatusBadge status={user.status} />
                </td>
                <td>{formatSolarDate(user.createdAt)}</td>
                <td><Link className="vania-users-row-action" to={`/users/${user.id}`} aria-label="مشاهده کاربر" title="مشاهده"><Eye size={14} aria-hidden="true" /><span className="sr-only">مشاهده</span></Link></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
  );
}
